import {
  Box,
  Stack
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { CircleCheck, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  CreateModalSuccessBox,
  DescriptionTypography,
  TextContent,
  TitleTypography
} from "./CreateModalSuccess.styles";
import { CreateModalSuccessProps } from "./CreateModalSuccess.types";
import { ButtonText } from "../../components";

export function CreateModalSuccess({
  onClose,
  ...props
}: CreateModalSuccessProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const titleRef = useRef<HTMLHeadingElement | null>(null);


  useEffect(() => {
    if (props.title ) {
      titleRef.current?.focus();
    }
  }, [props.title ]);

  return (

    <CreateModalSuccessBox
      role="dialog"
      aria-modal="true"
      aria-labelledby="success-title"
      container
      { ...props }
    >
      <Box
        sx={ {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "end",
          width: "100%"
        } }
      >
        <X
          aria-label={ t("close") }
          role="button"
          tabIndex={ 0 }
          size={ "1.5rem" }
          cursor="pointer"
          color={ theme.customColors?.textPrimary }
          onKeyDown={ (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if(onClose){
                onClose();
              }
            }
          } }
          onClick={ ()=> {
            if(onClose){
              onClose();
            }
          } }
        />
      </Box>
      <CircleCheck size={ "48px" }/>
      <TextContent>
        <TitleTypography
          ref={ titleRef }
          tabIndex={ -1 }
          id="success-title">
          {  props.title }
        </TitleTypography>
        <DescriptionTypography>
          { t("give_voice") }
        </DescriptionTypography>
        <Stack
          flexDirection="row"
          gap={ theme.spacing(1) }
          justifyContent={ "center" }
          marginTop={ "16px" }
        >
          <ButtonText
            sx={ {
              fontWeight:700,
              maxWidth:"120px",
              padding:theme.spacing(1,2)
            } }
            onClick={ ()=> {
              if(onClose){
                onClose();
              }

            } }
          >
            { t("continue") }
          </ButtonText>
        </Stack>
      </TextContent>
    </CreateModalSuccessBox>
  );
}
